export enum PackageRequestSource {
	EMAIL = 'EMAIL',
	USER = 'USER',
}

export enum SyncMortgagePackageStatus {
	PENDING = 'PENDING',
	GENERATED = 'GENERATED',
}

export interface SyncMortgageDocument {
	fileName: string;
	url: string;
}

export interface SyncMortgagePackage {
	source: PackageRequestSource;
	id: string;
	uploadedByEmail: string;
	lawyerId: string;
	institutionId: string;
	uploadedBy: string;
	uploadedAt: number;
	title?: string;
	description?: string;
	files: SyncMortgageDocument[];
	sent?: boolean;
	status: SyncMortgagePackageStatus;
	instructionId?: string;
	refId?: string; // TODO: This needs to be set by either us before we send or by InfotrackX ont he response
	deletedAt?: string;
}
